/**
 * Dependencies
 */
import React from 'react';
import DocumentTitle from 'react-document-title';

import classes from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';

import {
  Experiment,
  ExperimentControl,
  ExperimentVariant,
} from '@nerdwallet/features';

// Local Components
import VerticalComparison from '../components/front-page/vertical-comparison/vertical-comparison';
import CCBest from '../components/front-page/cc-best/cc-best';
import Testimonials from '../components/front-page/testimonials/testimonials';
import RegistrationModule from '../components/front-page/registration-module/registration-module';
import CampaignHighlight from '../components/front-page/campaign-highlight/campaign-highlight';

// Other Local Dependencies
import {
  verticalComparisonContent,
  ccBestContent,
  testimonialsContent,
  registrationModuleContent,
  campaignHighlightContent,
} from '../lib/front-page-content';

const TEST_NAME = 'josh_m_registration_test_experiment';
const VARIANT = 'variant';

const FrontPage = () => {
  const documentTitle = 'NerdWallet: Make all the right money moves';

  return (
    <React.Fragment>
      <Experiment testName={TEST_NAME}>
        <ExperimentControl>
          <DocumentTitle title={documentTitle} />
        </ExperimentControl>

        <ExperimentVariant name={VARIANT}>
          <DocumentTitle title={documentTitle} />
        </ExperimentVariant>
      </Experiment>

      <div>
        <div className={classNames([classes('padding-top-4')])}>
          <VerticalComparison {...verticalComparisonContent} />
        </div>
        <RegistrationModule {...registrationModuleContent} />
        <Testimonials {...testimonialsContent} />
        <CampaignHighlight {...campaignHighlightContent} />
        <CCBest {...ccBestContent} />
      </div>
    </React.Fragment>
  );
};

FrontPage.displayName = 'FrontPage';
FrontPage.analyticsName = 'nw_home_page';

FrontPage.propTypes = {};

export default FrontPage;
